import React from 'react';
import { usePage, Link } from '@inertiajs/react';

export default function TemplateShow() {
  const { whatsappTemplate, flash } = usePage<any>().props;

  if (!whatsappTemplate) return <div>Template not found</div>;

  return (
    <div className="max-w-screen-md mx-auto py-10 px-4 md:px-8">
      <div className="mb-6 flex justify-between items-center">
        <h1 className="text-2xl font-bold text-gray-800">
          Template: {whatsappTemplate.template_name || `ID #${whatsappTemplate.id}`}
        </h1>
        <div className="flex space-x-3">
          <Link href="/whatsapp_templates" className="text-gray-500 hover:text-gray-700 py-2">Back to List</Link>
          {['approved', 'rejected', 'paused'].includes(whatsappTemplate.status) && (
            <Link 
              href={`/whatsapp_templates/${whatsappTemplate.id}/edit`} 
              className="bg-indigo-600 hover:bg-indigo-700 text-white font-medium py-2 px-4 rounded shadow-sm"
            >
              Edit Template
            </Link>
          )}
        </div>
      </div>

      {flash?.notice && (
        <div className="bg-green-50 text-green-600 p-4 rounded mb-6 border border-green-200">
          {flash.notice}
        </div>
      )}

      <div className="bg-white shadow overflow-hidden sm:rounded-lg border border-gray-100">
        <div className="px-4 py-5 sm:px-6">
          <h3 className="text-lg leading-6 font-medium text-gray-900">Template Details</h3>
          <p className="mt-1 max-w-2xl text-sm text-gray-500">View current status and content of your Meta WhatsApp template.</p>
        </div>
        <div className="border-t border-gray-200 px-4 py-5 sm:p-0">
          <dl className="sm:divide-y sm:divide-gray-200">
            <div className="py-4 sm:py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
              <dt className="text-sm font-medium text-gray-500">Status</dt>
              <dd className="mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2">
                <span className={`px-2 inline-flex text-xs leading-5 font-semibold rounded-full 
                  ${whatsappTemplate.status === 'approved' ? 'bg-green-100 text-green-800' : 
                    whatsappTemplate.status === 'rejected' ? 'bg-red-100 text-red-800' : 
                    'bg-yellow-100 text-yellow-800'}`}>
                  {whatsappTemplate.status?.toUpperCase() || 'UNKNOWN'}
                </span>
                {whatsappTemplate.template_id && (
                  <span className="ml-3 text-gray-500">Meta ID: {whatsappTemplate.template_id}</span>
                )}
              </dd>
            </div>
            
            <div className="py-4 sm:py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
              <dt className="text-sm font-medium text-gray-500">Header format</dt>
              <dd className="mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2">
                {whatsappTemplate.header_format}
                {whatsappTemplate.header_format === 'text_header' && `: ${whatsappTemplate.header_text}`}
              </dd>
            </div>

            <div className="py-4 sm:py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
              <dt className="text-sm font-medium text-gray-500">Message Body</dt>
              <dd className="mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2 whitespace-pre-wrap">
                {whatsappTemplate.template_body}
              </dd>
            </div>
            
            <div className="py-4 sm:py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
              <dt className="text-sm font-medium text-gray-500">Footer Text</dt>
              <dd className="mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2">
                {whatsappTemplate.footer_text || <span className="text-gray-400 italic">None</span>}
              </dd>
            </div>
            
            {whatsappTemplate.whatsapp_template_buttons?.length > 0 && (
              <div className="py-4 sm:py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6 border-t border-gray-200">
                <dt className="text-sm font-medium text-gray-500">Buttons</dt>
                <dd className="mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2">
                  <ul className="border border-gray-200 rounded-md divide-y divide-gray-200">
                    {whatsappTemplate.whatsapp_template_buttons.sort((a, b) => a.position - b.position).map((btn: any) => (
                      <li key={btn.id} className="pl-3 pr-4 py-3 flex items-center justify-between text-sm">
                        <div className="w-0 flex-1 flex items-center">
                          <span className="flex-1 w-0 truncate">
                            <strong>{btn.button_text}</strong> <span className="text-gray-500">({btn.button_format.replace('_', ' ')})</span>
                            {btn.button_format === 'call_to_action' && <span className="ml-2 text-indigo-600">{btn.cta_value}</span>}
                          </span>
                        </div>
                      </li>
                    ))}
                  </ul>
                </dd>
              </div>
            )}
          </dl>
        </div>
      </div>
    </div>
  );
}
